import { SxProps } from '@mui/material/styles';
import { GLOBAL_MARGIN_HORIZONTAL, HEADER_HEIGHT } from 'src/app/constants';

const container: SxProps = {
  zIndex: 999,
  height: HEADER_HEIGHT,
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingLeft: GLOBAL_MARGIN_HORIZONTAL,
  paddingRight: GLOBAL_MARGIN_HORIZONTAL,
  width: '100%',
};

const containerMobile: SxProps = {
  zIndex: 999,
  height: HEADER_HEIGHT,
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
};

const logoContainer: SxProps = {
  position: 'absolute',
  left: 'calc(50% - 75px)',
  flexDirection: 'row',
  display: 'flex',
  alignItems: 'center',
};

const logoContainerSimple: SxProps = {
  flexDirection: 'row',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

const button: SxProps = {
  fontSize: '14px',
  lineHeight: 'auto',
  fontWeight: 400,
};

const logoImage = {
  height: 55,
  marginRight: -4,
};

const logoTitle: SxProps = {
  fontSize: '20px',
  lineHeight: '21px',
  fontWeight: 600,
  marginTop: 2,
};

export {
  container,
  logoContainer,
  button,
  logoImage,
  logoTitle,
  logoContainerSimple,
  containerMobile,
};
